/* eslint-disable @typescript-eslint/no-unused-vars */
export default abstract class TrackingService<DataType> {
  data: DataType;
  lastEventSerialized: string;

  isEventDuplicated(event: DataType) {
    const serializedEvent = JSON.stringify(event);
    if (this.lastEventSerialized === serializedEvent)
      return true;
    this.lastEventSerialized = serializedEvent;
    return false;
  }
}
